import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import { createError } from "../errorUtils.mjs";
const open = function(friendId, platform) {
  return new Promise(function(resolve, reject) {
    const friend = platform.friendsMap[friendId];
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv("devkit-instant-mock-context-switch", overlay);
    const box = createDiv("devkit-instant-mock-context-switch-box", container);
    const closeButton = createDiv("devkit-instant-mock-closeBtn", box);
    const icons = createDiv(null, box);
    createDiv(
      "devkit-instant-mock-context-switch-icon",
      icons
    ).style.backgroundImage = "url(" + platform.playerPhoto + ")";
    createDiv(
      "devkit-instant-mock-context-switch-icon",
      icons
    ).style.backgroundImage = "url(" + friend.photo + ")";
    createDom("h1", null, box).innerText = "Invite " + friend.name + " to play";
    const button = createDiv(
      "devkit-instant-mock-context-choose-item-btn devkit-instant-mock-context-switch-btn",
      box
    );
    button.innerText = "Invite";
    makeClickable(closeButton, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
    makeClickable(button, () => {
      removeDom(overlay);
      resolve(friend);
    });
  });
};
const contextSwitcher = { open };
export {
  contextSwitcher as default
};
